'use client';

import { useEffect } from 'react';

/** Dev-only: connect Reticle + install the React adapter, after hydration. */
export function ReticleDev() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    void import('@reticlehq/react').then(({ reticle, install }) => {
      install();
      const token = process.env.NEXT_PUBLIC_RETICLE_TOKEN;
      const root = process.env.NEXT_PUBLIC_RETICLE_ROOT;
      const url = process.env.NEXT_PUBLIC_RETICLE_URL;
      reticle.connect({
        projectId: 'webapp-093ca66e',
        ...(url ? { url } : {}),
        ...(token ? { token } : {}),
        ...(root ? { root } : {}),
      });
    });
  }, []);

  return null;
}
